"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_BLANK_INDEX = 28;
exports.EN_CHARS = ' abcdefghijklmnopqrstuvwxyz\'';
exports.EN_CHAR_MAP = {};
exports.EPSILON = 1e-5;
exports.IS_NODE = typeof (window) === 'undefined';
for (var index = 0, len = exports.EN_CHARS.length; index < len; index++) {
    exports.EN_CHAR_MAP[exports.EN_CHARS.charAt(index)] = index;
}
//# sourceMappingURL=constants.js.map